import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import { BookModel } from '../../../interfaces/book.interface';
import Loader from '../../../components/Common/Loader';
import { setShowShareModalData } from '../../../store/appSlice';
import { AppDispatch } from '../../../store/store';
import { useDispatch } from 'react-redux';
import { UserModel, UserRoleEnum } from '../../../interfaces/user.interface';
import { useStudentVPCStatus } from '../../../hooks/useStudentVPCStatus';

export type BookMenuMode = 'demo' | 'default';

interface BookMenuProps {
  className?: string;
  user?: UserModel | null;
  book: BookModel;
  mode?: BookMenuMode;
  index: number;
  archivedBooks: string;
  stripeSubscriptionStatus: boolean;
  loadingPDF: boolean[];
  selectedBook: { bookId: string | null; index: number | null };
  handleEditBook: (book: BookModel) => void;
  handleGeneratePdf: (bookId: string, index: number) => void;
  archiveBook: (bookId: string, fetchBooks: () => void) => void;
  unArchiveBook: (bookId: string, fetchBooks: () => void) => void;
  handleFetchBooks: () => void;
  setSelectedBook: (book: { bookId: string | null; index: number | null }) => void;
  setOpenDialog: (open: boolean) => void;
}

const BookMenu: React.FC<BookMenuProps> = ({
  className,
  book,
  user,
  mode = 'default',
  index,
  archivedBooks,
  stripeSubscriptionStatus,
  loadingPDF,
  selectedBook,
  handleEditBook,
  handleGeneratePdf,
  archiveBook,
  unArchiveBook,
  handleFetchBooks,
  setSelectedBook,
  setOpenDialog,
}: BookMenuProps) => {
  const dispatch: AppDispatch = useDispatch();
  const { vpcRequired, vpcComplete, teacherState, loading, isVPCBlocked, isVPCShareBlocked } = useStudentVPCStatus();

  const handleShareBook = (book: BookModel | null) => {
    dispatch(setShowShareModalData(book));
  };

  return (
    <div className={`w-[1rem] z-10 ${className}`}>
      <Menu>
        <Menu.Button className="w-8 pt-[3px] bg-storyblueSecondLightText hover:bg-storyblue rounded-md focus:outline-none">
          <FontAwesomeIcon icon={faEllipsisVertical} className="cursor-pointer text-white text-3xl" title="Menu" />
        </Menu.Button>
        <Menu.Items className="absolute right-0 top-[2rem] w-36 z-0 origin-top-right bg-gray-100 divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="px-1 py-1 flex flex-col items-baseline">
            {book?.coverURL && mode === 'default' && (
              <>
                {user?.role !== UserRoleEnum.student && (
                  <Menu.Item>
                    {({ active }) => (
                      <div className="flex items-baseline">
                        <Link
                          to={`/bookpurchase/${book.id}`}
                          className="w-full h-8  text-storygreen text-xs  hover:text-storyblue leading-none font-bold p-2 capitalize"
                        >
                          Purchase Story
                        </Link>
                      </div>
                    )}
                  </Menu.Item>
                )}
                {/*{user?.role === UserRoleEnum.student && (*/}
                {/*  <>*/}
                {/*    <Menu.Item>*/}
                {/*      {({ active }) => (*/}
                {/*        <div className="flex items-baseline">*/}
                {/*          {loading ? (*/}
                {/*            <div className="cursor-pointer">*/}
                {/*              <Loader loader={loading} />*/}
                {/*            </div>*/}
                {/*          ) : (*/}
                {/*            <Link*/}
                {/*              className={`${isVPCBlocked() ? 'text-gray-400 opacity-50 cursor-not-allowed' : ''} w-full h-8  text-storygreen text-xs  hover:text-storyblue leading-none font-bold p-2 capitalize`}*/}
                {/*              onClick={(e) => isVPCBlocked() && e.preventDefault()}*/}
                {/*              to={isVPCBlocked() ? `/bookpurchase/${book.id}` : ''}*/}
                {/*            >*/}
                {/*              Purchase Story*/}
                {/*            </Link>*/}
                {/*          )}*/}
                {/*        </div>*/}
                {/*      )}*/}
                {/*    </Menu.Item>*/}
                {/*  </>*/}
                {/*)}*/}

                <Menu.Item>
                  {({ active }) => (
                    <>
                      <Link to={`/bookflip/${book.id}`}>
                        <div className="w-full h-8  text-storygreen text-xs   hover:text-storyblue leading-none font-bold p-2 capitalize">
                          FlipBook
                        </div>
                      </Link>
                    </>
                  )}
                </Menu.Item>

                <Menu.Item>
                  {({ active }) => (
                    <div className="flex items-baseline">
                      {!book?.pdfUrl ? (
                        <>
                          <button
                            onClick={() => {
                              handleGeneratePdf(book?.id!, index);
                            }}
                            disabled={loadingPDF[index]}
                            className="w-full flex items-center h-8  text-storygreen text-xs  hover:text-storyblue leading-none font-bold p-2 capitalize"
                          >
                            Generate Pdf
                            <Loader loader={loadingPDF[index]} />
                          </button>
                        </>
                      ) : (
                        <>
                          <Link
                            to={book?.pdfUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-full h-8  text-storygreen text-xs  hover:text-storyblue leading-none font-bold p-2 capitalize"
                          >
                            View PDF
                          </Link>
                        </>
                      )}
                    </div>
                  )}
                </Menu.Item>
              </>
            )}

            <Menu.Item>
              {({ active }) => (
                <div className="flex items-baseline">
                  <button
                    onClick={() => handleEditBook(book)}
                    className={`w-full h-8  text-storygreen text-xs   hover:text-storyblue leading-none font-bold p-2 capitalize ${!stripeSubscriptionStatus && 'inactive-menu-item'}`}
                  >
                    Edit Story
                  </button>
                </div>
              )}
            </Menu.Item>

            {book.shareUrl && user?.role !== UserRoleEnum.student && (
              <Menu.Item>
                {({ active }) => (
                  <div className="flex items-baseline">
                    <button
                      onClick={() => handleShareBook(book)}
                      className={`w-full h-8  text-storygreen text-xs   hover:text-storyblue leading-none font-bold p-2 capitalize`}
                    >
                      Share Story
                    </button>
                  </div>
                )}
              </Menu.Item>
            )}
            {book.shareUrl && user?.role === UserRoleEnum.student && (
              <Menu.Item>
                {({ active }) => (
                  <div className="flex items-baseline">
                    {loading ? (
                      <div className="cursor-pointer">
                        <Loader loader={loading} />
                      </div>
                    ) : (
                      <button
                        onClick={(e) => (isVPCShareBlocked() ? e.preventDefault() : handleShareBook(book))}
                        className={`${isVPCShareBlocked() ? 'text-gray-400 opacity-50 cursor-not-allowed' : ''} w-full h-8  text-storygreen text-xs   hover:text-storyblue leading-none font-bold p-2 capitalize`}
                      >
                        Share Story
                      </button>
                    )}
                  </div>
                )}
              </Menu.Item>
            )}

            {mode === 'default' && (
              <>
                {user?.role !== UserRoleEnum.student && (
                  <Menu.Item>
                    {({ active }) => (
                      <div>
                        {archivedBooks === 'yes' ? (
                          <>
                            <button
                              onClick={() => unArchiveBook(book?.id!, handleFetchBooks)}
                              className="w-full flex items-center h-8  text-storygreen text-xs  hover:text-storyblue leading-none font-bold p-2 capitalize"
                            >
                              UnArchive
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              onClick={() => archiveBook(book?.id!, handleFetchBooks)}
                              className="w-full flex items-center h-8  text-storygreen text-xs  hover:text-storyblue leading-none font-bold p-2 capitalize"
                            >
                              Archive
                            </button>
                          </>
                        )}
                      </div>
                    )}
                  </Menu.Item>
                )}
                {user?.role !== UserRoleEnum.student && (
                  <Menu.Item>
                    {({ active }) => (
                      <div className="flex items-baseline">
                        <button
                          onClick={() => {
                            setSelectedBook({
                              ...selectedBook,
                              bookId: book?.id!,
                              index,
                            });
                            setOpenDialog(true);
                          }}
                          className="w-full h-8  text-red-500 text-xs  hover:text-storyblue leading-none font-bold p-2 capitalize"
                        >
                          Delete
                        </button>
                      </div>
                    )}
                  </Menu.Item>
                )}
              </>
            )}
          </div>
        </Menu.Items>
      </Menu>
    </div>
  );
};

export default BookMenu;
